module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgUlEQVQ4Ee2UwQnAIAxFfztRRuiIjuQIjlIn+EXqobXRHAyFQgM5vfwHkuBCEp61uto+KwwAIgAZ5KTOhAcpS2k68qydpChcKmOdvXFNeA200hHrCntBUzYSalJTZglbqSkr7X7Yrz3ZdSnuZzN12L2lZAAbgKSwVFnWgv9/OFkADilXXQFAgPt6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_msg_panel_close.png
// module id = MzCX
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82